import React, { useState } from 'react';
import TCOCDeepDive from './TCOCDeepDive';
import TCOCGeneral from './TCOCGeneral';
import TCOCBenchmark from './TCOCBenchmark';
import './ERDashboard.css';
import './TCOCDashboard.css';

function TCOCDashboardMain() {
  const [activeTab, setActiveTab] = useState('deepdive');
  const [benchmarkData, setBenchmarkData] = useState(() => {
    // Try to load from localStorage on mount
    const saved = localStorage.getItem('tcoc_benchmark_data');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error('Error parsing saved benchmark data:', e);
      }
    }
    // Default values
    return {
      benchmarks: {
        ESRD: 0,
        DIS: 0,
        AD: 0,
        ND: 0
      },
      trends: {
        ESRD: 1,
        DIS: 1,
        AD: 1,
        ND: 1
      },
      riskScores: {
        ESRD: 0,
        DIS: 0,
        AD: 0,
        ND: 0
      }
    };
  });

  return (
    <div style={{ width: '100%', margin: 0, padding: 0, backgroundColor: '#f3f4f6', minHeight: '100vh', boxSizing: 'border-box' }}>
      {/* Header with Icon and Buttons */}
      <div style={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #e5e7eb',
        padding: '20px',
        marginBottom: '0px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '100%',
          margin: '0 auto'
        }}>
          <h1 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1f2937',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            💰 TCOC Dashboard
          </h1>
          <div style={{
            display: 'flex',
            gap: '12px'
          }}>
            <button
              onClick={() => setActiveTab('deepdive')}
              style={{
                padding: '10px 20px',
                backgroundColor: activeTab === 'deepdive' ? '#4caf50' : '#a5d6a7',
                color: activeTab === 'deepdive' ? 'white' : '#2e7d32',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: activeTab === 'deepdive' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
          }}
        >
          PY DEEP DIVE
        </button>
        <button
          onClick={() => setActiveTab('general')}
          style={{
            padding: '10px 20px',
            backgroundColor: activeTab === 'general' ? '#4caf50' : '#a5d6a7',
            color: activeTab === 'general' ? 'white' : '#2e7d32',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: activeTab === 'general' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
          }}
        >
          PY GENERAL
        </button>
        <button
          onClick={() => setActiveTab('benchmark')}
          style={{
            padding: '10px 20px',
            backgroundColor: activeTab === 'benchmark' ? '#4caf50' : '#a5d6a7',
            color: activeTab === 'benchmark' ? 'white' : '#2e7d32',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: activeTab === 'benchmark' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
          }}
        >
          BMK INPUT
        </button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
        {activeTab === 'deepdive' && <TCOCDeepDive benchmarkData={benchmarkData} />}
        {activeTab === 'general' && <TCOCGeneral benchmarkData={benchmarkData} />}
        {activeTab === 'benchmark' && <TCOCBenchmark benchmarkData={benchmarkData} setBenchmarkData={setBenchmarkData} />}
      </div>
    </div>
  );
}

export default TCOCDashboardMain;
